import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { connect, useConnect } from '@puzzlehq/sdk';
import { VStack, Button, Spinner, Text, HStack } from 'ui_2';
import { Route as GameIndexRoute } from '@routes/game/index';
import { Route as MintRoute } from '@src/routes/game/mint';
import { LoadingMessage } from '@src/components/LoadingMessage';
import { BackgroundHighRes } from '@src/components/BackgroundHighRes';
import { SquashHighRes } from '@src/components/SquashHighRes';
import { MuteButton } from '@src/components/MuteButton';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { connectRequest } from '@src/data/utils';
import { useIntroAudio } from '@src/hooks/useAudio';
import { useSquashGameState } from '@src/providers/squashGameState';
import {
  SquashHistoryButton,
  SquashHistoryButtonLarge,
} from '@src/components/SquashHistoryButton';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      const connectResponse = await connect(connectRequest);
      console.log('/ connectResponse', connectResponse);
    } catch (e) {
      console.error(e);
    }
  },
  pendingComponent: () => <LoadingMessage message='Loading your game' />,
  component: function Component() {
    const { activeSquash } = useSquashGameState();
    const { isConnected, loading, connect } = useConnect(connectRequest);
    const navigate = useNavigate({ from: Route.id });
    const { height } = useWindowDimensions();
    useIntroAudio();

    return (
      <div className='relative h-full w-full'>
        <div className='absolute right-0 top-0 z-50 m-4'>
          <HStack className='items-center gap-2'>
            <SquashHistoryButton />
            <MuteButton />
          </HStack>
        </div>
        <div
          className={`relative w-full ${
            height < 750 ? 'h-[48vh]' : 'h-[55vh]'
          }`}
        >
          <div className='absolute inset-0'>
            <BackgroundHighRes isIntro={true} />
            <SquashHighRes isIntro={true} />
          </div>
        </div>

        <VStack className='mt-4 items-center text-center lg:text-[42px] lg:font-bold'>
          <Text font='bold-xl' family='atak'>
            SQUASH{height > 850 ? <br /> : ' '}GAME
          </Text>
          <Text font='regular-lg' family='atak'>
            Farm. Grow. Earn.
          </Text>
        </VStack>

        <div className='absolute bottom-0 pb-4'>
          <VStack className='items-center gap-4'>
            <div className='flex h-[120px] w-[80%] items-center justify-center rounded-lg bg-gray-100 p-4'>
              <Text font='regular-sm' family='atak'>
                You are about to be given a Squash Baby to farm. Everyday you
                need to water it and if you prove to have a green thumb you will
                be rewarded.
              </Text>
            </div>
            {!isConnected && (
              <Button
                onClick={async () => {
                  const response = await connect();
                  console.log('connect response', response);
                }}
                className='w-[80%] gap-2'
                disabled={loading}
              >
                {loading ? 'Connecting' : 'Connect'}
                {loading && <Spinner />}
              </Button>
            )}
            {isConnected && (
              <VStack className='w-[80%] items-center gap-2'>
                <Button
                  onClick={() => {
                    if (activeSquash) {
                      console.log(
                        'Squash Detected! Navigating to GameIndexRoute'
                      );
                    } else {
                      console.log(
                        'No Squash Detected! Navigating to MintRoute'
                      );
                    }
                    return navigate({
                      to: activeSquash ? GameIndexRoute.to : MintRoute.to,
                    });
                  }}
                  className='w-full'
                >
                  {activeSquash ? 'Play' : 'Mint'}
                </Button>
                <SquashHistoryButtonLarge />
              </VStack>
            )}
          </VStack>
        </div>
      </div>
    );
  },
});
